import { DocumentNode, gql } from '@apollo/client'

export const GET_TOKEN: DocumentNode = gql`
    query GetToken($token: String!) {
        getToken(token: $token)
    }
`
